interface IGraphContainer extends HTMLElement {
    button?: HTMLButtonElement;
}

export default class MultiDiagram {
    protected minHeight = 0;
    constructor() {
        const _this = this;

        if (document.querySelectorAll('.cmsZone .multi-diagram').length) {
            _this.initEditmode();
            return;
        }

        window.addEventListener('graphDataLoaded', (data: CustomEvent) => {
            _this.evDataLoaded(data);
        });
    }

    /**
     * Editmode activate click events for checkbox buttons
     */
    initEditmode() {
        document
            .querySelectorAll('.cmsZone .multi-diagram .outer-btn input')
            .forEach((checkbox: HTMLInputElement) => {
                checkbox.addEventListener('input', () => {
                    checkbox.parentElement.classList.toggle('btn-checked');
                });
            });
    }

    /**
     * fires when data is loaded
     *
     * @param ev CustomEvent
     * @returns
     */
    evDataLoaded(ev: CustomEvent) {
        if (!ev.detail.properties) {
            return;
        }
        const graphButton = <HTMLButtonElement>(
            document.querySelector('.rw-station-name-' + ev.detail.properties.id)
        );

        if (!graphButton) {
            return;
        }

        if (!ev.detail.properties.stationName) {
            graphButton.remove();
            return;
        }
        graphButton.querySelector('.loader').remove();
        graphButton.querySelector('.hidden').classList.remove('hidden');
        graphButton.querySelector('.stationName div').textContent =
            ev.detail.properties.stationName + ' [' + ev.detail.properties.stationType + ']';
        const trend = ev.detail.properties?.trend;
        if (trend) {
            const trendIcon = document.createElement('span');
            trendIcon.className = 'icon-trend ' + trend;
            graphButton.querySelector('.state-outer').insertAdjacentElement('beforeend', trendIcon);
        }
        const publicState = parseInt(ev.detail.properties.publicState);
        graphButton.querySelectorAll('.state-inner img').forEach((img: HTMLImageElement, index) => {
            if (publicState === index) {
                img.src = '/img/signal/light-top-' + (index + 1) + '-on.png';
            } else {
                img.src = '/img/signal/light-top-' + (index + 1) + '-off.png';
            }
        });

        const stationData = graphButton.querySelector('.stationData');
        ev.detail.properties.current.forEach((element, index) => {
            const param = <HTMLElement>document.createElement('div');
            if (element) {
                param.innerHTML =
                    element.parameter +
                    ': ' +
                    (!isNaN(parseFloat(element.eventValue))
                        ? parseFloat(element.eventValue).toFixed(2)
                        : 'Keine Messung') +
                    ' ' +
                    element.units;
                stationData.insertAdjacentElement('beforeend', param);
                if (index === 1) {
                    const br = document.createElement('br');
                    stationData.insertAdjacentElement('beforeend', br);
                }
            }
        });


        graphButton.addEventListener('click', () => {
            graphButton
                .closest('.graph-navi')
                .querySelectorAll('button')
                .forEach((el) => {
                    el.classList.remove('active');
                });
            graphButton.classList.add('active');

            graphButton
                .closest('.graph-container')
                .querySelectorAll('.graph-inner')
                .forEach((graph: HTMLElement) => {
                    if (graph.classList.contains(graphButton.dataset.connect)) {
                        graph.classList.remove('opacity-0');
                        graph.classList.add('opacity-1');
                    } else {
                        graph.classList.remove('opacity-1');
                        graph.classList.add('opacity-0');
                        graph.style.position = 'absolute';
                    }
                });
        });


        let minHeight = 0;
        document.querySelectorAll('.multi-diagram').forEach((container: HTMLElement) => {
            container
                .querySelectorAll('.graph-navi button.btn')
                .forEach((graphButton: HTMLButtonElement, index) => {
                    const graph = <HTMLElement>(
                        container.querySelector('.' + graphButton.dataset.connect)
                    );
                    if (index > 0) {
                        graph.classList.add('opacity-0');
                        graph.style.position = 'absolute';
                    } else {
                        graph.classList.add('opacity-1');
                        graphButton.classList.add('active');
                    }
                    const rect = container.getBoundingClientRect();
                    minHeight = minHeight < rect.height ? rect.height : minHeight;
                });
            container.style.minHeight = minHeight + 'px';
        });
    }
}
